module.exports = __webpack_public_path__ + "static/media/GoalSetting.a9818bfc.jpg";